import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import styled from "styled-components";
import tw from "twin.macro";
import { getPageProductType } from "api/ProductTypeApi";
import { ProductCateCountApi } from "api/ProductCategoryApi";
import SEO from "./Seo";

export const NavLink = tw.span`my-2 tracking-wide transition duration-300 text-black hover:text-custom-100  pb-2 lg:pb-5 no-underline border-b-4 border-transparent hover:border-custom-100 text-base lg:text-sm lg:mx-4 lg:my-0 xl:text-base xl:mx-6`;

export const LogoLink = styled(NavLink)`
  ${tw`py-2`};
  img {
    ${tw`mr-3`}
  }
`;

export default function CategorysMenu() {
  const [data, setData] = useState([]);
  const [count, setCount] = useState([]);
  const [lists, setLists] = useState([//eslint-disable-line
    "gold",
    "silver",
    "diamond",
    "platinum",
  ]);
  const [state, setState] = useState({ isTechWalletEnable: false }); //eslint-disable-line

  useEffect(() => {
    getProductType();
    // getTechWalletConfigData();
    //eslint-disable-next-line
  }, []);

  let history = useNavigate();

  const getProductCount = (productId) => {
    let filter = {
      // visibilityMode: "MOBILE",
      metaProdTypeEnty: productId,
      // allowCatalogue: 1,
    };
    ProductCateCountApi(filter).then((data) => {
      const categoryData = data.response.filter(
        (item) =>
          item.visibilityMode === "WEB_MOBILE" ||
          item.visibilityMode === "MOBILE",
      );
      setCount(categoryData);
    });
  };

  const getProductType = () => {
    const arr1 = [];
    const arr2 = [];
    let isChecked = false;
    let equlprod = [];
    let notEqulprod = [];

    let filterData = {
      active: 1,
    };
    getPageProductType(filterData).then((data) => {
      let response = data.response.content;
      lists.forEach((item, idx) => {
        if (!isChecked) {
          equlprod.length = 0;
          arr1.push(...response.filter((x) => x.name.toLowerCase() === item));
          arr2.push(...response.filter((x) => x.name.toLowerCase() !== item));
          isChecked = true;
        } else {
          arr1.push(...arr2.filter((x) => x.name.toLowerCase() === item));
          const newarr = arr2;
          notEqulprod = newarr.filter((x) => x.name.toLowerCase() !== item);
          arr2.length = 0;
          arr2.push(...notEqulprod);
        }
        if (lists.length - 1 === idx) {
          arr1.push(...arr2);
        }
      });
      // const pageData =  response.reverse()
      // let cropData= pageData.slice(0,5)
      let cropData = arr1.slice(0, 6);
      setData(cropData);
    });
  };

  return (
    <>
      <SEO
        title="AMR Sumangalee Jewellers"
        description="Beginner friendly page for learning React Helmet."
        name="Company name."
        type="article"
      />
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav mx-auto mb-2 mb-lg-0 header">
          {data?.map((data, idx) => {
            return (
              <li
                key={idx}
                className="nav-item dropdown"
                onMouseEnter={() => getProductCount(data.id)}
                onMouseLeave={() => setCount(0)}
              >
                <div
                  className="nav-link ps-4 text-uppercase"
                  id="navbarDropdown"
                  role="button"
                  aria-expanded="false"
                  style={{ whiteSpace: "nowrap" }}
                  onClick={() =>
                    history("/ProductList", { state: { type: data } })
                  }
                >
                  {data.name}
                </div>
                {count?.length > 0 ? (
                  <div
                    className="dropdown-menu py-3 rounded border"
                    aria-labelledby="navbarDropdown"
                  >
                    <ul>
                      {count?.map((category, index) => (
                        <motion.li
                          key={index}
                          className="d-flex align-items-center"
                          initial={{
                            y: 300,
                            x: 0,
                            opacity: 0,
                          }}
                          animate={{
                            y: 0,
                            x: 0,
                            opacity: 1,
                          }}
                          exit={{
                            opacity: 0,
                          }}
                        >
                          <motion.a
                            className="dropdown-item"
                            style={{
                              whiteSpace: "normal",
                              cursor: "pointer",
                            }}
                            whileHover={{
                              scale: 1.1,
                              originX: 0,
                              fontWeight: 700,
                            }}
                            transition={{ type: "spring", stiffness: 300 }}
                            layout
                            onClick={() => {
                              history("/ProductList", {
                                state: { category: category },
                              });
                            }}
                          >
                            {category.categoryName}
                          </motion.a>
                        </motion.li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  <div
                    className="dropdown-menu py-3 w-25 opacity-0"
                    aria-labelledby="navbarDropdown"
                  >
                    <ul className="d-block w-100">
                      <li className="w-100">
                        <span
                          className="dropdown-item"
                          style={{
                            whiteSpace: "normal",
                            cursor: "pointer",
                          }}
                        >
                          No - data
                        </span>
                      </li>
                    </ul>
                  </div>
                )}
              </li>
            );
          })}
          {data?.length > 0 && (
            <li className="nav-item dropdown">
              <Link className="nav-link px-4 text-uppercase" to="/SchemeList">
                Saving scheme
              </Link>
            </li>
          )}
          {state.isTechWalletEnable ? (
            <li className="nav-item dropdown">
              <Link className="nav-link px-4 text-uppercase" to="/TechWallet">
                Tech Wallet
              </Link>
            </li>
          ) : null}
        </ul>
      </div>
    </>
  );
}
